import { render } from "./CanvaLayout.vue?vue&type=template&id=57db2ef9&scoped=true&ts=true"
import script from "./CanvaLayout.vue?vue&type=script&lang=ts"
export * from "./CanvaLayout.vue?vue&type=script&lang=ts"

import "./CanvaLayout.vue?vue&type=style&index=0&id=57db2ef9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57db2ef9"]])

export default __exports__